import { useCapabilitiesStore } from '@/stores/capabilities'
import { FEATURES, useFeaturesStore } from '@/stores/features'
import { useRoomStore } from '@/stores/room'

interface UseSetAudioFlagsStateProps {
  memberId: string
}

/**
 * The `setAudioFlags` capability enables users to configure audio processing flags
 * (echo cancellation, auto gain control, noise suppression) via the `call.setAudioFlags` method.
 * - See `SetAudioFlagsParams` type in the SDK for available options.
 */
export const useSetAudioFlagsState = ({
  memberId,
}: UseSetAudioFlagsStateProps) => {
  const selfMemberId = useRoomStore(state => state.memberId)
  const isSelf = memberId === selfMemberId

  const hasCapability = useCapabilitiesStore(state =>
    isSelf ? state.selfAudioFlagsCapability : state.memberAudioFlagsCapability,
  )

  const isFeatureDisabled = useFeaturesStore(state =>
    isSelf
      ? state.disabled.SELF_SET_AUDIO_FLAGS === FEATURES.SELF_SET_AUDIO_FLAGS
      : state.disabled.MEMBER_SET_AUDIO_FLAGS ===
        FEATURES.MEMBER_SET_AUDIO_FLAGS,
  )

  const isVisible = hasCapability && !isFeatureDisabled

  return {
    isSetAudioFlagsEnabled: hasCapability,
    isSetAudioFlagsVisible: isVisible,
  }
}
